import { useEffect, useRef } from 'react'

import { Button } from '@/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/web-admin/table'
import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {
  loginData: {
    name: string
    email: string
    password: string
  }[]
  title?: string
}

export const SchoolUserLoginDataModal = ({
  isOpen,
  loginData,
  title = 'ユーザーの作成が完了しました',
  onRequestClose,
  ...rest
}: Props): JSX.Element => {
  const excellentExportRef = useRef<any>(null)

  const handleDownloadExcel = () => {
    if (!excellentExportRef.current) return

    return excellentExportRef.current.convert(
      {
        anchor: 'download-excel-anchor',
        filename: 'login_data',
        format: 'xlsx',
      },
      [
        {
          name: 'Sheet1',
          from: {
            table: 'excel-table',
          },
        },
      ]
    )
  }

  useEffect(() => {
    if (typeof window === undefined) return

    const init = async () => {
      excellentExportRef.current = await import('excellentexport')
    }

    init()

    return () => {
      excellentExportRef.current = null
    }
  }, [])

  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          padding: '40px 60px',
          width: '700px',
          maxWidth: '700px',
          backgroundColor: '#F5F7FC',
        },
      }}
      showCloseButton={false}
      shouldCloseOnOverlayClick={false}
      onRequestClose={onRequestClose}
      {...rest}
    >
      <h3 className="mb-6 text-center text-2xl font-bold">{title}</h3>

      <p className="mb-5 text-center text-[15px] font-medium">
        以下のIDとパスワードで、LOGIQ LABOへログインすることができます。
      </p>

      <Table variant="enterprise" className="mb-10">
        <TableHeader>
          <TableRow>
            <TableHead>氏名</TableHead>
            <TableHead>ID</TableHead>
            <TableHead>パスワード</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {loginData.map((data, index) => (
            <TableRow key={index}>
              <TableCell className="h-[49px]">{data.name}</TableCell>
              <TableCell className="h-[49px] text-secondary-text">
                {data.email}
              </TableCell>
              <TableCell className="h-[49px] text-secondary-text">
                {data.password}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <p className="text-center text-[15px] font-medium">
        ログイン用のパスワードはウェブからは確認できなくなりますので、ダウンロードして安全に管理してください。
      </p>

      {/* excel table */}
      <table id="excel-table" className="hidden">
        <thead>
          <tr>
            <th>氏名</th>
            <th>ID</th>
            <th>パスワード</th>
          </tr>
        </thead>
        <tbody>
          {loginData.map((data, index) => (
            <tr key={index}>
              <td>{data.name}</td>
              <td>{data.email}</td>
              <td>{data.password}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-5 flex justify-center gap-4">
        <Button
          variant="secondary"
          className="w-full max-w-[310px]"
          asChild={true}
        >
          <a
            id="download-excel-anchor"
            href="#"
            download="login_data.xlsx"
            onClick={(e) => {
              handleDownloadExcel()
              onRequestClose?.(e)
            }}
          >
            Excelでダウンロードして 閉じる
          </a>
        </Button>
      </div>
    </Modal>
  )
}
